import React from 'react';
import AddressToString from '../AddressToString';

const NewGasLineAvailable = ({ address1, address2, serviceCost, isTwoMeter }) => {
    const serviceAvailable =  window.osa && window.osa.lookup &&  window.osa.lookup.serviceAddress &&  window.osa.lookup.serviceAddress.available;
    return (
        <div>

            <h4 className="text-available">
                <AddressToString message={serviceAvailable && serviceAvailable.atAddress} {...address1} inTwoLine={isTwoMeter} />
            </h4>
            {
                isTwoMeter ?
                    <h4 className="text-available">
                        <AddressToString {...address2} />
                    </h4>
                    : null
            }
            <h4>{serviceAvailable && serviceAvailable.cost + '$' + serviceCost + '.'}</h4>
            <p>{serviceAvailable && serviceAvailable.note}</p>
        </div>
    );
};
NewGasLineAvailable.propTypes = {
    address1: React.PropTypes.object,
    address2: React.PropTypes.object,
    serviceCost: React.PropTypes.number,
    isTwoMeter: React.PropTypes.bool
};
export default NewGasLineAvailable;